export const AboutFoxit = {
  "Modal": {
    "Title_1": "Foxit PDF Editor",
    "Visit": "Visit",
    "Website": "Foxit Website"
  },
  "Content": {
    "Title": "This software uses, with permissions, the following copyrighted materials:"
  }
}